import { UserStatus } from '../types/UserInfoTypes';

export const getIsUserInactive = (status?: string) =>
  status ? status === UserStatus.Inactive : false;
